const initialState = {
    isLoggedIn: false,
    user: localStorage.getItem('user')?JSON.parse(localStorage.getItem('user')):null,
    auth_token: localStorage.getItem('auth_token'),
    refresh_token: localStorage.getItem('refreshToken'),
    loading: false,
    pageloading: false,
    error: null,
    message: null,
    all_users:[],
  };
  
  export default function authReducer(state = initialState, action) {
    switch (action.type) {
        case 'LOGIN_REQUEST':
        return { ...state, loading: true };       
        case 'LOGIN_SUCCESS':
        return { user: null,loading: false,pageloading: false,refresh_token:action.payload.refresh_token,auth_token: action.payload.id_token,isLoggedIn :true, error: null,message: "Login Successfull!", };
        case 'LOGIN_FAILURE':
        return { loading: false, user: null,isLoggedIn :false, error: action.payload,message: action.payload };
        case 'REFRESH_TOKEN':
        return { ...state, auth_token: action.payload.id_token };
        case 'USER':
        return { ...state, user: action.payload,error: null,message:null };
        case 'ALL_USERS':
        return { ...state, all_users: (action.payload).reverse(),error: null,message:null };
        case 'CREATE_USER':
          return { ...state, all_users: [...state.all_users, action.payload],error: null,message:null };
        
        case 'CHECK_VALID_RESET_LINK_REQUEST':
          return { ...state, pageloading: true };
        case 'CHECK_VALID_RESET_LINK_SUCCESS':
            return { ...state, pageloading: false };
        case 'CHECK_VALID_RESET_LINK_FAILURE':
          return { pageloading: false,loading: false, user: null,isLoggedIn :false, error: action.payload,message: action.payload };
        case 'LOGOUT_APP':
            return {  isLoggedIn: false,
                user: null,
                all_users:[],
                auth_token: null,
                refresh_token: null,
                loading: false,
                error: null,
                message: action.payload };
        default:
            
        return state;
    }
  }
  